<template>
	<v-dialog v-model="clienteDialog" max-width="1024" scrollable>
		<v-card>
			<v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
			<v-card-title class="pb-0">
				<v-icon left>mdi-cellphone</v-icon>
				Aplicativos
				<v-spacer></v-spacer>
				<v-btn icon @click="dialogClose">
					<v-icon>close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text>
				<v-row class="mt-4 mb-4" justify="end">
					<v-col>
						<v-text-field v-model="cliente.chaveApps" label="Chave" readonly hide-details>
							<template v-slot:append>
								<v-icon color="primary" @click="copiarChave(cliente.chaveApps)">
									mdi-content-copy
								</v-icon>
							</template>
						</v-text-field>
					</v-col>
					<v-col>
						<v-text-field label="Chave Mobile" v-model="cliente.chaveAppsMobile" readonly hide-details>
							<template v-slot:append>
								<v-icon color="primary" @click="copiarChave(cliente.chaveAppsMobile)">
									mdi-content-copy
								</v-icon>
							</template>
						</v-text-field>
					</v-col>
					<v-col cols="3">
						<v-btn color="primary" :disabled="cliente.unificarChaves || !cliente.ativo"
							@click="unificarChaves()" :loading="loading" large block>Unificar chaves</v-btn>
					</v-col>
				</v-row>
				<v-tabs v-model="tab" grow optional>
					<v-tab key="notificaTab" @click="loadDispositivos"><v-icon>mdi-bell</v-icon>Notifica</v-tab>
					<v-tab key="catalogoTab"><v-icon>mdi-store</v-icon>E-commerce</v-tab>
					<v-tab key="cotacaoTab"><v-icon>mdi-list-box</v-icon>Cotação</v-tab>
					<!-- <v-tab key="gestaoTab"><v-icon>mdi-poll</v-icon>Gestão</v-tab> -->
					<v-tab key="pedidosTab" @click="loadDispositivosPedidos"><v-icon>mdi-cart</v-icon>Pedidos</v-tab>
					<!-- <v-tab key="foodsTab"><v-icon>mdi-silverware-fork-knife</v-icon>Foods</v-tab> -->

					<v-tabs-items v-model="tab">
						<v-tab-item key="notificaTab" v-if="userAplicativos || userAdmin">
							<v-row>
								<v-col cols="3">
									<v-checkbox label="Ativar SIC Notifica" v-model="usarNotifica"
										:disabled="!cliente.ativo" @change="setUsarNotifica()"
										hide-details></v-checkbox>
								</v-col>
								<!-- <v-col cols="3">
									<v-text-field label="Quantidade de Dispositivos"
										type="number"></v-text-field>
								</v-col> -->
							</v-row>

							<NotificaTab :dispositivos="dispositivos"/>
						</v-tab-item>
						<v-tab-item key="catalogoTab" v-if="userAplicativos || userAdmin">
							<v-checkbox label="Ativar SIC E-commerce" v-model="usarCatalogo" :disabled="!cliente.ativo"
								@change="setUsarCatalogo()" hide-details></v-checkbox>
						</v-tab-item>
						<v-tab-item key="cotacaoTab" v-if="userAplicativos || userAdmin">
							<v-checkbox label="Ativar SIC Cotação" v-model="usarCotacao" :disabled="!cliente.ativo"
								@change="setUsarCotacao()" hide-details></v-checkbox>
						</v-tab-item>
						<v-tab-item key="pedidosTab" v-if="userAplicativos || userAdmin">
							<v-row class="mt-3">
								<v-col cols="3">
									<v-checkbox label="Ativar SIC Pedidos" v-model="cliente.usarPedidos"
										:disabled="!cliente.ativo" @change="setUsarPedidos()"
										hide-details></v-checkbox>
								</v-col>
								<v-col cols="4">
									<v-checkbox label="Confirmar novos dispositivo" v-model="cliente.confirmarDispositivosPedidos"
										:disabled="!cliente.ativo" @change="setConfirmarDispositivos()"
										hide-details></v-checkbox>
								</v-col>
								<v-col cols="3">
									<v-text-field label="Quantidade de Dispositivos"
										type="number" v-model="qtdDispositivosPedidos" :disabled="!(userAplicativos || userAdmin)" min="1"></v-text-field>
								</v-col>
								<v-btn color="primary" class="mt-5 ml-2" v-if="(userAplicativos || userAdmin) && qtdDispositivosPedidos!= cliente.qtdDispositivosPedidos" @click="setQtdDispositivos">Salvar</v-btn>
							</v-row>
							<PedidosTab :dispositivos="dispositivosPedidos" @dispositivosChanged="loadDispositivosPedidos" />
						</v-tab-item>
					</v-tabs-items>
				</v-tabs>
				<!-- <v-row justify="start">
					<v-col>
						<v-checkbox label="Cotação" v-model="usarCotacao" :disabled="!cliente.ativo"
							@change="setUsarCotacao()" hide-details></v-checkbox>
					</v-col>
					<v-col>
						<v-checkbox label="Notifica" v-model="usarNotifica" :disabled="!cliente.ativo"
							@change="setUsarNotifica()" hide-details></v-checkbox>
					</v-col>
					<v-col>
						<v-checkbox label="Catálogo" v-model="usarCatalogo" :disabled="!cliente.ativo"
							@change="setUsarCatalogo()" hide-details></v-checkbox>
					</v-col>
				</v-row> -->
				<!-- <v-row>
					<v-col class="pt-0">
						<v-text-field v-model="cliente.chaveApps" label="Chave" readonly hide-details>
							<template v-slot:append>
								<v-icon color="primary" @click="copiarChave(cliente.chaveApps)">
									mdi-content-copy
								</v-icon>
							</template>
						</v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col class="pt-0">
						<v-text-field label="Chave Mobile" v-model="cliente.chaveAppsMobile" readonly hide-details>
							<template v-slot:append>
								<v-icon color="primary" @click="copiarChave(cliente.chaveAppsMobile)">
									mdi-content-copy
								</v-icon>
							</template>
						</v-text-field>
					</v-col>
				</v-row> -->
				<!-- <v-row>
					<v-col>
						<v-btn color="primary" :disabled="cliente.unificarChaves || !cliente.ativo"
							@click="unificarChaves()" :loading="loading">Unificar chaves</v-btn>
					</v-col>
				</v-row> -->
			</v-card-text>
		</v-card>
	</v-dialog>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import NotificaTab from './aplicativos/NotificaTab.vue'
import PedidosTab from './aplicativos/PedidosTab.vue'

export default {
	props: {
		cliente: Object,
		dialog: Boolean,
	},
	components: {
		NotificaTab,
		PedidosTab
	},
	data: function () {
		return {
			loading: false,
			usarCotacao: this.cliente.usarCotacao == 'S' ? true : false,
			usarNotifica: this.cliente.usarNotifica == 'S' ? true : false,
			usarCatalogo: this.cliente.usarCatalogo == 'S' ? true : false,
			tab: null,
			dispositivos: [],
			dispositivosPedidos:[],
			qtdDispositivosPedidos: 0
		}
	},
	computed: {
		...mapGetters(['userAdmin', 'userMaster', 'userAplicativos']),
		...mapState(['user']),
		clienteDialog: {
			get() {
				return this.dialog
			},
			set() {
				this.dialogClose()
			},
		},
	},
	methods: {
		dialogClose() {
			this.tab = null
			this.$emit('dialogClose')
		},
		loadCliente() {
			this.$emit('loadCliente')
		},
		copiarChave(chave) {
			navigator.clipboard
				.writeText(chave)
				.then(() => {
					this.$store.dispatch('showSuccess', 'Chave copiada com sucesso!')
				})
				.catch(() => {
					this.$store.dispatch('showError', 'Erro ao copiar chave!')
				})
		},
		async setUsarCotacao() {
			try {
				this.loading = true
				await this.axios.put(`/clientes/${this.cliente.id}/apps/usarcotacao`, {
					usarCotacao: this.usarCotacao,
				})
				const msg = this.usarCotacao
					? 'O cliente agora pode usar a Cotação Web'
					: 'O cliente agora não pode usar a Cotação Web!'
				this.$store.dispatch('showSuccess', msg)
			} catch (error) {
				this.usarCotacao = !this.usarCotacao
				this.$store.dispatch('showError', 'Erro! Tente novamente mais tarde!')
			} finally {
				this.loading = false
			}
		},
		async setUsarNotifica() {
			try {
				this.loading = true
				await this.axios.put(`/clientes/${this.cliente.id}/apps/usarnotifica`, {
					usarNotifica: this.usarNotifica,
				})
				const msg = this.usarNotifica
					? 'O cliente agora pode usar o Notifica'
					: 'O cliente agora não pode usar o Notifica!'
				this.$store.dispatch('showSuccess', msg)
			} catch (error) {
				this.usarNotifica = !this.usarNotifica
				this.$store.dispatch('showError', 'Erro! Tente novamente mais tarde!')
			} finally {
				this.loading = false
			}
		},
		async setUsarCatalogo() {
			try {
				this.loading = true
				await this.axios.put(`/clientes/${this.cliente.id}/apps/usarcatalogo`, {
					usarCatalogo: this.usarCatalogo,
				})
				const msg = this.usarCatalogo
					? 'O cliente agora pode usar o Catálogo'
					: 'O cliente agora não pode usar o Catálogo!'
				this.$store.dispatch('showSuccess', msg)
			} catch (error) {
				this.usarCatalogo = !this.usarCatalogo
				this.$store.dispatch('showError', 'Erro! Tente novamente mais tarde!')
			} finally {
				this.loading = false
			}
		},
		async setUsarPedidos() {
			try {
				this.loading = true
				await this.axios.put(`/clientes/${this.cliente.id}/apps/usarpedidos`, {
					usarPedidos: this.cliente.usarPedidos,
				})
				const msg = this.cliente.usarPedidos
					? 'O cliente agora pode usar o Pedidos'
					: 'O cliente agora não pode usar o Pedidos!'
				this.$store.dispatch('showSuccess', msg)
			} catch (error) {
				this.cliente.usarPedidos = !this.cliente.usarPedidos
				this.$store.dispatch('showError', 'Erro! Tente novamente mais tarde!')
			} finally {
				this.loading = false
			}
		},
		async setConfirmarDispositivos() {
			try {
				this.loading = true
				await this.axios.put(`/clientes/${this.cliente.id}/apps/confirmardispositivos`, {
					confirmarDispositivos: this.cliente.confirmarDispositivosPedidos,
				})
				const msg = this.cliente.confirmarDispositivosPedidos
					? 'Agora será necessário confirmar os novos dispositivos!'
					: 'Agora NÃO será necessário confirmar os novos dispositivos!'
				this.$store.dispatch('showSuccess', msg)
			} catch (error) {
				this.cliente.confirmarDispositivosPedidos = !this.cliente.confirmarDispositivosPedidos
				this.$store.dispatch('showError', 'Erro! Tente novamente mais tarde!')
			} finally {
				this.loading = false
			}
		},
		async setQtdDispositivos() {
            try {
				this.loading = true
				await this.axios.put(`/clientes/${this.cliente.id}/qtdDispositivos`, {
					qtdDispositivos: this.qtdDispositivosPedidos,
				})

				this.cliente.qtdDispositivosPedidos = this.qtdDispositivosPedidos

				this.$store.dispatch('showSuccess', "Quantidade de dispositivos alterada com sucesso!")
			} catch (error) {
				this.cliente.qtdDispositivosPedidos = !this.cliente.qtdDispositivosPedidos
				this.$store.dispatch('showError', 'Erro! Tente novamente mais tarde!')
			} finally {
				this.loading = false
			}
        }, 
		async unificarChaves() {
			try {
				this.loading = true
				await this.axios.put(`/clientes/${this.cliente.id}/apps/unificar`)
				this.$store.dispatch('showSuccess', 'Chaves unificadas com sucesso!')
				this.loadCliente()
			} catch (error) {
				this.$store.dispatch('showError', 'Erro! Tente novamente mais tarde!')
			} finally {
				this.loading = false
			}
		},
		async loadDispositivos() {
			try {
				this.loading = true

				const response = await this.axios.get(`/dispositivos/${this.cliente.chaveApps}/listarporchave`, {
					baseURL: 'https://api.notifica.sicplug.com.br'
				})

				if (response.data.msg == 'Empresa não existe!') this.dispositivos = []
				else this.dispositivos = response.data

			} catch (error) {
				this.$store.dispatch('showError', error)
			} finally {
				this.loading = false
			}
		},
		async loadDispositivosPedidos() {
			try {
				this.loading = true
				const response = await this.axios.get(`/clientes/${this.cliente.id}/rdispositivos`)
				this.dispositivosPedidos = response.data
			} catch (error) {
				this.$store.dispatch('showError', error)
			} finally {
				this.loading = false
			}
		},
	},
	watch: {
		cliente() {
			this.usarCotacao = this.cliente.usarCotacao == 'S' ? true : false
			this.usarNotifica = this.cliente.usarNotifica == 'S' ? true : false
			this.usarCatalogo = this.cliente.usarCatalogo == 'S' ? true : false
			this.qtdDispositivosPedidos = this.cliente.qtdDispositivosPedidos
		}
	}
}
</script>